var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "change-bag-seal"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Update Bag Seal Number")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Seal Changed Reason")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class ='fa fa-industry'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('Reason')
    },
    attrs: {
      "name": "Reason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.reason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Reason")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Seal Broken while Bag Close"
    }
  }, [_vm._v("Seal Broken while Bag Close")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Seal Broken While Packing"
    }
  }, [_vm._v("Seal Broken While Packing")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Seal Damage"
    }
  }, [_vm._v("Seal Damage")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SealNo not Readable"
    }
  }, [_vm._v("SealNo not Readable")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Reason')),
      expression: "errors.has('Reason')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Reason')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Old Bag Seal No")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-bag'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.oldbagsealno),
      expression: "oldbagsealno"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('OldBagSealNo')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Old Bag Seal No",
      "name": "OldBagSealNo",
      "id": "OldBagSealNo"
    },
    domProps: {
      "value": (_vm.oldbagsealno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldbagsealno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('OldBagSealNo')),
      expression: "errors.has('OldBagSealNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('OldBagSealNo')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showBagDetails
    }
  }, [_vm._v("Show")])])]), _vm._v(" "), (_vm.isBagData) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('fieldset', {
    staticStyle: {
      "margin-left": "16px",
      "width": "1032px"
    }
  }, [_c('label', [_vm._v("Bag Seal Details")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-bordered mytable12",
    staticStyle: {
      "width": "97%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag Seal No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Coloader Name")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.bagDetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s("--"))])])
  }), _vm._v(" "), ((_vm.bagDetails && _vm.bagDetails.length == 0) || _vm.bagDetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)])])], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("New Bag Seal No")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-bag'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newbagsealno),
      expression: "newbagsealno"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('NewBagSealNo')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter New Bag Seal No",
      "name": "NewBagSealNo",
      "id": "NewBagSealNo"
    },
    domProps: {
      "value": (_vm.newbagsealno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newbagsealno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('NewBagSealNo')),
      expression: "errors.has('NewBagSealNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('NewBagSealNo')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.IsDisable == true
    }
  }, [_vm._v("Save")]), _vm._v("  \n              "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Cancel")])])])])], 1)])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25a522fa","hasScoped":true}!./src/views/components/changeBagSeal/changeBagSeal.html
// module id = 1177
// module chunks = 2